import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface PayableChargesSummary {
  totalPrincipal: number;
  totalInterest: number;
  totalFine: number;
  totalDiscount: number;
  totalFee: number;
  paymentIds: string[];
}

/**
 * Soma juros/multa/desconto/tarifa por payable_id para exibição na listagem (sem alterar AP).
 */
export function usePayablePaymentCharges(payableIds: string[]) {
  const sortedKey = [...payableIds].sort().join(',');

  return useQuery({
    queryKey: ['payable-payment-charges', sortedKey],
    queryFn: async (): Promise<Record<string, PayableChargesSummary>> => {
      if (!payableIds.length) return {};

      const { data, error } = await supabase
        .from('payable_payments')
        .select('id, payable_id, payment_value, interest_value, fine_value, discount_value, fee_value')
        .in('payable_id', payableIds);

      if (error) throw error;

      const map: Record<string, PayableChargesSummary> = {};
      for (const row of data || []) {
        const principal = Number(row.payment_value) || 0;
        const interest = Number(row.interest_value) || 0;
        const fine = Number(row.fine_value) || 0;
        const discount = Number(row.discount_value) || 0;
        const fee = Number(row.fee_value) || 0;
        if (!map[row.payable_id]) {
          map[row.payable_id] = { totalPrincipal: 0, totalInterest: 0, totalFine: 0, totalDiscount: 0, totalFee: 0, paymentIds: [] };
        }
        map[row.payable_id].totalPrincipal += principal;
        map[row.payable_id].paymentIds.push(row.id);
        map[row.payable_id].totalInterest += interest;
        map[row.payable_id].totalFine += fine;
        map[row.payable_id].totalDiscount += discount;
        map[row.payable_id].totalFee += fee;
      }
      return map;
    },
    enabled: payableIds.length > 0,
    staleTime: 60_000,
  });
}
